var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmartPlugPowerOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 37,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#005D98",
  d: "M22.694 10.438c.486 0 .973.468.973.937v.938c0 .527-.487.937-.973.937h-.971V17c0 4.746-3.647 8.555-8.265 9.258V31a1 1 0 0 1-1 1h-.916a1 1 0 0 1-1-1v-4.742a10.2 10.2 0 0 1-2.906-.895L9.79 23.21a7 7 0 0 0 2.21.354c3.707 0 6.806-2.93 6.806-6.563v-2.806l3.756-3.757zm-6.496 0-2.812 2.812H5.194V17a6.37 6.37 0 0 0 1.004 3.436l-2.071 2.072A9.06 9.06 0 0 1 2.277 17v-3.75h-.971c-.547 0-.973-.41-.973-.937v-.938c0-.469.426-.937.973-.937zM6.167 2c.79 0 1.458.645 1.458 1.406v5.156H4.708V3.407C4.708 2.645 5.316 2 6.167 2m11.666 0c.79 0 1.459.645 1.459 1.406v3.938l-1.219 1.218h-1.698V3.407c0-.761.608-1.406 1.458-1.406"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#005D98",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M4 26.232 23.232 7"
})));
export default SvgSmartPlugPowerOff;